import script from "./studentSubscriptionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./studentSubscriptionPlans.vue?vue&type=script&setup=true&lang=js"

import "./studentSubscriptionPlans.vue?vue&type=style&index=0&id=0e237c2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e237c2f"]])

export default __exports__